import useAuth from 'hooks/useAuth'

import { useGlobal } from 'raducer/global'
import { useEffect, useRef } from 'react'
import { ChatMsgPusher } from '../pusher'
import useChat from './useChat'
import { updateChatListCache } from '../functions'
import { TChatListData } from '../types'

export type TUnreadCountResp = {
 total_unread_count?: number
 user_id?: any
 lead_id?: any
 chat_id?: any
 unread_chat_count?: any
 last_message_date?: string
 last_message?: string
 lead_email?: string
 lead_name?: string
 transferowner?: any
}

const usePusherUnread = () => {
 const { user, isAuthenticated } = useAuth()
 const { updateChatCount } = useGlobal()
 const { state, updateChatList, updateChatListById } = useChat()

 // useref to fix stale closure
 const stateRef = useRef(state)

 useEffect(() => {
  stateRef.current = state
 }, [state])

 useEffect(() => {
  if (isAuthenticated) {
   const channel = ChatMsgPusher.subscribe(`unreadCount.${user?.id}`)
   channel.bind('unread-count', async (data: { data: TUnreadCountResp }) => {
    if (data && data.data) {
     const res = data.data
     //  console.log({ res, state })

     if (res.total_unread_count != null) {
      updateChatCount?.(res.total_unread_count)
     }

     if (res?.chat_id) {
      const currentState = stateRef.current
      if (currentState.screen === 'chatHistory') {
       updateChatListCache({
        chat_id: res?.chat_id,
        unread_chat_count: res?.unread_chat_count,
        last_message_date: res?.last_message_date,
        last_message: res?.last_message,
        transferowner: res?.transferowner,
       })
      } else {
       const isChatList = currentState.chatList?.find(
        (chat: TChatListData) => chat.id === res.chat_id,
       )
       if (isChatList) {
        updateChatListById?.({
         id: res?.chat_id,
         data: {
          unReadCount: res?.unread_chat_count,
          leadEmail: res?.lead_email,
          leadName: res?.lead_name,
          leadId: res?.lead_id,
          transferowner: res?.transferowner,
         },
        })
       } else {
        updateChatList?.({
         id: res?.chat_id,
         leadEmail: res?.lead_email,
         leadName: res?.lead_name,
         leadId: res?.lead_id,
         unReadCount: res?.unread_chat_count,
         transferowner: res?.transferowner,
        })
       }
      }
     }
    }
   })

   return () => {
    ChatMsgPusher.unsubscribe(`unreadCount.${user?.id}`)
   }
  }
 }, [user?.id, isAuthenticated])

 return {}
}

export default usePusherUnread
